import { render, staticRenderFns } from "./openInfo.vue?vue&type=template&id=3e06641e"
import script from "./openInfo.vue?vue&type=script&lang=js"
export * from "./openInfo.vue?vue&type=script&lang=js"
import style0 from "./openInfo.vue?vue&type=style&index=0&id=3e06641e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports